import classes from "./logo.module.css";

export default function Logo() {
  return <div className={classes.logo} />;
}
